import {BackgroundImage, Box, Button, Center, Image, Text} from '@mantine/core';
import type React from 'react';
import {
  REPORT_ANALYTICS_BACKGROUND,
  REPORT_ANALYTICS_LOGO,
} from '../../../../config/constants/img';
import {getAIGradient} from '../../usecase/getAIGradient';

type Props = Record<string, never>;

export const NoDataBox: React.FC<Props> = () => {
  return (
    <Box className="pc:w-[1200px] w-full h-full flex flex-col justify-center items-center">
      <BackgroundImage
        src={REPORT_ANALYTICS_BACKGROUND}
        className="w-full mb-24"
      >
        <Center p={100} className="flex-col">
          <Box className="mb-12">
            <Image src={REPORT_ANALYTICS_LOGO} alt="AI選考対策" width={200} />
          </Box>
          <Box className="w-[200px] flex flex-col items-center justify-center">
            <Text className="text-white text-lg whitespace-nowrap">
              分析できるデータがありませんでした。
            </Text>
            <Text className="text-white  text-lg whitespace-nowrap">
              他の企業・部門で検索してみてください。
            </Text>
          </Box>
        </Center>
      </BackgroundImage>
      <Box className="pc:w-1/3 w-full px-16">
        <Button
          radius="xl"
          size="xl"
          className="text-md"
          style={{
            background: getAIGradient(),
          }}
          fullWidth
          onClick={() => {
            window.location.href = '/report_analytics/search';
          }}
        >
          他の企業で分析する
        </Button>
      </Box>
    </Box>
  );
};
